import React, { useState } from 'react'
import './ConnectionInfo.css'
import ServiceNavbar from '../../../../../components/SubNavbar/SubNavbar'

function ConnectionInfo({target, source}) {

    const [currentPage, setCurrentPage] = useState("info")

    return (
        <div className='connection-info'>
            <ServiceNavbar setPage={(page)=>setCurrentPage(page)} options = {[
                "info",
                "resources",
                "endpoints"
            ]}
            />
            {currentPage === "info" && 
            <div className='page info-page'>
                
            </div>}
            {currentPage === "sources" && 
            <div className='page sources-page'>
                
            </div>}
            {currentPage === "endpoints" && 
            <div className='page endpoints-page'>

            </div>}
        </div>
    )
    }



export default ConnectionInfo